const GET_AZURE_METRICS_AVAILABILITY = "GET_AZURE_METRICS_AVAILABILITY";
const GET_AZURE_METRICS_AVAILABILITY_SUCCESS =
  "GET_AZURE_METRICS_AVAILABILITY_SUCCESS";
const GET_AZURE_METRICS_AVAILABILITY_ERROR =
  "GET_AZURE_METRICS_AVAILABILITY_ERROR";

export {
  GET_AZURE_METRICS_AVAILABILITY,
  GET_AZURE_METRICS_AVAILABILITY_SUCCESS,
  GET_AZURE_METRICS_AVAILABILITY_ERROR,
};
